import { Mapping } from '@teetsh/app/src/containers/Eleves/Import/File/csv';

export function getFieldFromRow(row: object, field?: Mapping) {
  if (!field || !field?.header) {
    return undefined;
  }

  return row[field?.header];
}
